import { Button, Card, Input } from 'antd'
import { useState } from 'react'

import { useRoleActions } from '../hooks/useRoleActions'
import { useRoleConfirm } from '../hooks/useRoleConfirm'
import type { RoleDetail } from '../hooks/useRoleDetail'

interface Props {
  role: RoleDetail
  refetch: () => void
  readOnly: boolean
}

export function RoleDescriptionCard({ role, refetch, readOnly }: Props) {
  const { updateRoleDescription } = useRoleActions()
  const { confirmDescription } = useRoleConfirm()
  const [description, setDescription] = useState(role.description ?? '')

  const dirty = description !== (role.description ?? '')

  const save = () => {
    confirmDescription(role.name, async () => {
      await updateRoleDescription(role.name, description)
      refetch()
    })
  }

  return (
    <Card title="Description" style={{ marginBottom: 16 }}>
      <Input.TextArea
        rows={3}
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        placeholder="Optional description"
        disabled={readOnly}
      />
      <Button
        type="primary"
        style={{ marginTop: 12 }}
        disabled={readOnly || !dirty}
        onClick={save}
      >
        Save Description
      </Button>
    </Card>
  )
}
